import React from "react";
import get from 'lodash/get'
import style from './custombutton.module.css'
import {Button} from "@material-ui/core";

const CustomButton = (props)=>{
    const buttonDisabled = get(props,"buttonDisabled",false)
    const title = get(props,"title",false)
    return (

        <Button
            variant="contained"
            color="secondary"
            type="submit"
            fullWidth
            onClick={props.onSubmitHandler||null}
            disabled={buttonDisabled}
            className={buttonDisabled? style.custom_button_disabled_style: style.custom_button_style}
            style={buttonDisabled?null:{ backgroundColor: "#2e5790"}}
        >
            {title}
        </Button>
    )
}

export default CustomButton